import store from '../data/store'
export default {
  name: 'bio',
  mounted() {
    let id = this.$route.params.id
    store.dispatch('artistBio', {
      name: decodeURI(id)
    })
  },
  computed: {
    centerContent () {
      return store.state.similarArtist.length <= 0
    }
  },
  methods: {
    newArtiest(name){
      store.dispatch('artistBio', {
        name: name
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mv/bio.js